import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "@phosphor-icons/react";
import Logo from "../components/Logo";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center px-4 noise-bg" data-testid="payment-cancel-page">
      <div className="mb-10"><Logo /></div>
      <div className="card-surface p-8 sm:p-12 max-w-md w-full text-center">
        <XCircle size={56} weight="fill" className="text-neutral-500 mx-auto mb-6" />
        <h1 className="font-display text-2xl sm:text-3xl font-semibold text-white mb-3">Checkout canceled</h1>
        <p className="text-neutral-400 text-sm mb-8">
          No worries — nothing was charged. Pick a plan whenever you're ready; your 7-day free trial starts the moment you add a card.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/pricing" className="btn-primary rounded-full px-6 py-3 text-sm inline-flex items-center gap-2" data-testid="payment-cancel-retry">
            <ArrowLeft size={14} weight="bold" /> Back to pricing
          </Link>
          <Link to="/app/dashboard" className="rounded-full px-6 py-3 text-sm border border-white/15 text-neutral-200 hover:text-white hover:border-white/30 transition-colors">
            Continue on trial
          </Link>
        </div>
      </div>
    </div>
  );
}
